import React from 'react'
import { Button, Popup, Icon } from 'semantic-ui-react'

export default class NeedSupportPopup extends React.PureComponent {
  render() {
    const { onResolve, needSupport } = this.props

    return (
      <Popup
        hideOnScroll
        wide
        trigger={<Icon name="chat" size="large" color="orange" style={{ cursor: 'pointer' }} />}
        on="click"
        position="right center"
      >
        <div>{needSupport}</div>
        <div style={{ textAlign: 'center' }}>
          <Button size="mini" onClick={onResolve} style={{ margin: 0, marginTop: 10 }}>
            Resolve ?
          </Button>
        </div>
      </Popup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/lib/NeedSupportPopup.js